import React from 'react';
import { amcTitleCase } from '../../utils';
import amcStyles from '../../styles/amcs.scss';

interface DocumentsRequiredProps {
  issuingAuthority: string;
}

const DocumentsRequired: React.FC<DocumentsRequiredProps> = ({
  issuingAuthority,
}) => {
  return (
    <div className="lil-pt-10 lil-w-full sm:lil-pt-4">
      <h2
        className={`${amcStyles['plan-title']} lil-pt-4 lil-pb-8 sm:lil-pb-6`}
      >
        Documents Required to Invest in {amcTitleCase(issuingAuthority)}
      </h2>
      <div className="lil-pb-6">
        The documents for KYC (Know Your Client) include proof of address and
        proof of identity. Here is a list of officially valid documents (OVD)
        admissible.
      </div>
      <div className="lil-w-full lil-flex lil-flex-wrap lil-justify-center lil-gap-20 sm:lil-gap-6">
        <div className="lil-flex-1 lil-bg-blue-50 lil-px-6 lil-rounded-lg">
          <h3 className="lil-text-s-24 sm:lil-text-s-20 lil-font-medium lil-px-4 lil-pt-10 lil-pb-6">
            Proof of Identity
          </h3>
          <ul
            style={{ color: '#314259B2' }}
            className="lil-px-10 sm:lil-px-6 lil-pb-10"
          >
            <li className="lil-list-disc">PAN Card (Mandatory)</li>
            <li className="lil-list-disc">Voter ID Card</li>
            <li className="lil-list-disc">Driving License</li>
            <li className="lil-list-disc">Passport</li>
            <li className="lil-list-disc">Aadhaar Card</li>
            <li className="lil-list-disc">
              Any other valid identity card issued by the Central or State
              Government
            </li>
          </ul>
        </div>
        <div className="lil-flex-1 lil-bg-blue-50 lil-px-6 lil-rounded-lg sm:lil-mt-0">
          <h3 className="lil-text-s-24 sm:lil-text-s-20 lil-font-medium lil-px-4 lil-pt-10 lil-pb-6">
            Proof of Address
          </h3>
          <ul
            style={{ color: '#314259B2' }}
            className="lil-px-10 sm:lil-px-6 lil-pb-10"
          >
            <li className="lil-list-disc">Voter ID Card</li>
            <li className="lil-list-disc">Driving License</li>
            <li className="lil-list-disc">Passport</li>
            <li className="lil-list-disc">Ration Card</li>
            <li className="lil-list-disc">Aadhaar Card</li>
            <li className="lil-list-disc">
              Bank account statement or bank passbook
            </li>
            <li className="lil-list-disc">
              Utility bills like electricity or gas bills
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DocumentsRequired;



// WEBPACK FOOTER //
// ./components/amcNew/DocumentsRequired.tsx